<template>
    <SimpleTable formclass="Store/form" endpoint="stores" :aditionalColumns="headers" inlineToggle hideDelete>
        <template>
            <h1>Cadastro de Lojas</h1>
            <v-divider class="mb-4"></v-divider>
        </template>
    </SimpleTable>
</template>

<script>
import SimpleTable from "@/components/core/SimpleTable";
export default {
    components: {
        SimpleTable,
    },
    data() {
        return {
            headers: [
                { text: this.$t("Habilitado"), value: "enable", align: "right", sortable: false },
                { text: this.$t("Bairro"), value: "district", align: "right", sortable: true },
                { text: this.$t("Cidade"), value: "city", align: "right", sortable: true },
                { text: this.$t("Nome"), value: "name", align: "right", sortable: true },
            ],
        };
    },
};
</script>